import React from 'react';
import { Modal, Form, Button, Spinner } from 'react-bootstrap';

export default function ModalInativar(props) {
    var show = props.show;
    var onHide = props.onHide;
    var campanha = props.campanha;
    var motivo = props.motivo;
    var onChangeMotivo = props.onChangeMotivo;
    var onConfirmar = props.onConfirmar;
    var salvando = props.salvando;

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Inativar Campanha</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {campanha && (
                    <div>
                        <p>Deseja realmente inativar a campanha <strong>{campanha.nome}</strong>?</p>
                        <Form.Group>
                            <Form.Label>Motivo da inativacao (opcional)</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Informe o motivo da inativacao..."
                                value={motivo}
                                onChange={function (e) { onChangeMotivo(e.target.value); }}
                            />
                        </Form.Group>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={salvando}>
                    Cancelar
                </Button>
                <Button variant="danger" onClick={onConfirmar} disabled={salvando}>
                    {salvando ? (
                        <Spinner animation="border" size="sm" />
                    ) : (
                        'Inativar'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
